export default __webpack_public_path__ + "static/media/SY.93495bd5.svg";